import React from "react";
import LatestUpdatesJSON from "../assests/JSON/LatestUpdates.json";
import "../styles/LatestUpdate.css";

const Latestupdate = () => {
  return (
    <section>
      <div className="latest-updates-container">
        <h2 className="updates-heading">Latest Updates</h2>
        {LatestUpdatesJSON.map((item, index) => (
          <div key={index} className="update-block">
            <h3 className="update-date">{item.date}</h3>
            <ul className="update-list">
              {item.updates.map((point, idx) => (
                <li key={idx} className="update-point">
                  {point}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Latestupdate;
